<div class="flex gap-1 items-center">
  <div>
    <label>{{ itemList.length }} 筆</label>
  </div>
  <button class="btn-normal" (click)="onFirstRow()" matTooltip="第一筆">
    <mat-icon>first_page</mat-icon>
  </button>
  <button class="btn-normal" (click)="onPreviousRow()" matTooltip="上一筆">
    <mat-icon>navigate_before</mat-icon>
  </button>
  <button class="btn-normal" (click)="doShowInfo($event)">
    <mat-icon>more_vert</mat-icon>
  </button>
  <button class="btn-normal" (click)="onNextRow()" matTooltip="下一筆">
    <mat-icon>navigate_next</mat-icon>
  </button>
  <button class="btn-normal" (click)="onLastRow()" matTooltip="最後一筆">
    <mat-icon>last_page</mat-icon>
  </button>
  <button
    class="btn-normal w-11 h-9"
    (click)="gridHeightChange(20)"
    matTooltip="表格增高"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="33" viewBox="0 0 72 56" role="img" aria-labelledby="title desc">
      <title id="title">垂直放大</title>
      <desc id="desc">向上與向下展開內容的按鈕</desc>
      <defs>
        <linearGradient id="expandFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#86efac"/>
          <stop offset="1" stop-color="#22c55e"/>
        </linearGradient>
      </defs>
      <path d="M36 8.5v10.75M30.75 13.75 36 8.5l5.25 5.25M36 47.5V36.75M30.75 42.25 36 47.5l5.25-5.25" fill="none" stroke="#334155" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.25"/>
      <rect x="27" y="22" width="18" height="12" rx="4" fill="url(#expandFill)" stroke="#15803d" stroke-width="1.75"/>
      <path d="M31 28h10" stroke="#fff" stroke-linecap="round" stroke-width="2.25"/>
    </svg>
  </button>
  <button
    class="btn-normal w-11 h-9"
    (click)="gridHeightChange(-20)"
    matTooltip="表格縮小🤏"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.2"
      height="33.6"
      viewBox="0 0 72 56"
      role="img"
      aria-labelledby="title desc"
    >
      <title id="title">垂直縮小</title>
      <desc id="desc">向中央壓縮內容的按鈕</desc>
      <defs>
        <linearGradient id="collapseFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#fdba74" />
          <stop offset="1" stop-color="#f97316" />
        </linearGradient>
      </defs>
      <path
        d="M36 9v10.5M30.75 14.25 36 19.5l5.25-5.25M36 47V36.5M30.75 41.75 36 36.5l5.25 5.25"
        fill="none"
        stroke="#334155"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3.25"
      />
      <rect
        x="27"
        y="22"
        width="18"
        height="12"
        rx="4"
        fill="url(#collapseFill)"
        stroke="#c2410c"
        stroke-width="1.75"
      />
      <path
        d="M31 28h10"
        stroke="#fff"
        stroke-linecap="round"
        stroke-width="2.25"
      />
    </svg>
  </button>
  <button class="btn-normal" (click)="onSumAll()" matTooltip="總計">
    <mat-icon>summarize</mat-icon>
  </button>
  <app-jkedit
    [width]="40"
    placeholder="快搜"
    [showClearButton]="false"
    [(value)]="gridSearchValue"
  >
  </app-jkedit>
  <button [class.btn-query]="true" (click)="searchGrid(gridSearchValue)">
    <mat-icon
      fontIcon="search"
      slot="start"
      name="search-circle-outline"
    ></mat-icon>
  </button>
  <app-jkedit
    [width]="40"
    placeholder="快篩,其中包含...[需enter]"
    [showClearButton]="false"
    [(value)]="gridFilterValue"
    (valueChange)="onFilterTextBoxChanged($event)"
  >
  </app-jkedit>
</div>

<div class="w-full" [cdkContextMenuTriggerFor]="context_menu">
  <ag-grid-angular
    #myGrid
    [theme]="gridSrv.theme"
    [ngStyle]="gridStyle"
    [columnDefs]="columnDefs"
    [columnTypes]="gridSrv.columnTypes"
    [defaultColDef]="gridSrv.defaultColDef"
    [localeText]="gridSrv.localeText"
    [pagination]="gridSrv.pagination"
    [paginationPageSize]="gridSrv.paginationPageSize"
    [paginationPageSizeSelector]="gridSrv.paginationPageSizeSelector"
    [rowSelection]="gridSrv.rowSelection"
    [rowData]="itemList"
    (gridReady)="onGridReady($event)"
    (keydown)="onKeydown($event)"
    (rowClicked)="onRowClicked($event)"
    (rowDoubleClicked)="onRowDoubleClicked($event)"
    [enableBrowserTooltips]="true"
    (cellValueChanged)="onCellValueChanged($event)"
    (rowSelected)="onRowSelected($event)"
    (onSelectionChanged)="onSelectionChanged()"
    [editType]="'fullRow'"
    (rowEditingStarted)="onRowEditingStarted($event)"
    (rowEditingStopped)="onRowEditingStopped($event)"
  >
  </ag-grid-angular>
</div>

<ng-template #context_menu>
  <div class="jk-menu" cdkMenu>
    @if (isJkaggrid) {
      <button class="jk-menu-item" cdkMenuItem (click)="doUIEdit()">
        修改
      </button>
      <button class="jk-menu-item" cdkMenuItem (click)="doUIInsert()">
        新增
      </button>
      <button class="jk-menu-item" cdkMenuItem (click)="doUIDelete()">
        刪除
      </button>
      <button class="jk-menu-item" cdkMenuItem (click)="doSetup()">
        管理員設定
      </button>
    }
    <button class="jk-menu-item" cdkMenuItem (click)="doFilter('')">
      過濾條件
    </button>
    <button class="jk-menu-item" cdkMenuItem (click)="reloadGrid()">
      重新整理
    </button>
    <button class="jk-menu-item" cdkMenuItem>取消功能表</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doItemList()">
      資料內容(json)
    </button>
    <button
      class="jk-menu-item"
      cdkMenuItem
      (click)="doMyExportExcel(itemList)"
    >
      匯出Excel(xlsx)
    </button>
    <button
      class="jk-menu-item"
      cdkMenuItem
      (click)="gridSrv.doSaveTitle(columnDefs)"
    >
      存欄位設定
    </button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doResetTitle()">
      重置欄位設定
    </button>
    <button
      class="jk-menu-item"
      cdkMenuItem
      (click)="gridSrv.doShowManagerField(columnDefs)"
    >
      顯示管理欄位
    </button>
    <button class="jk-menu-item" cdkMenuItem (click)="doShowInfo($event)">
      表格資訊
    </button>
  </div>
</ng-template>

<!-- (rowDoubleClicked)="onRowDoubleClicked($event as any)" (afterGridReady)="afterGridReady($event) -->
<!--     <app-jkgridwin #jkgridwin id="jkgridwin" [width]="screenWidth" [defaultHeight]="500"  (rowClicked)="onRowClicked($event)"
      >
    </app-jkgridwin>
 -->
@if (showAdvanced()) {
  <mat-toolbar class="mat-toolbar-flex bg-blue-300 border-solid">
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="doFilter('')"
    >
      過濾條件
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="doUIInsert()"
    >
      新增
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="doUIDelete()"
    >
      刪除
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="reloadGrid()"
    >
      重新整理
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="showSelectedItem()"
    >
      秀選取資料
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="showAllItems()"
    >
      秀全部資料
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="doUIGridEdit()"
    >
      grid編輯
    </button>
    <button
      class="btn-normal"
      [class.btn-primary]="true"
      (click)="doEditAndSave()"
    >
      grid存檔
    </button>
    <mat-select
      [(ngModel)]="bookTypeItem"
      matTooltip="格式"
      placeholder="匯出格式"
    >
      @for (idNameItem of bookTypeList; track idNameItem) {
        <mat-option [value]="idNameItem">{{ idNameItem.name }}</mat-option>
      }
    </mat-select>
  </mat-toolbar>
}
